import RegistryRequestApproval from "./RegistryRequestApproval";
import RegistryRequestTable from "./RegistryRequestTable";

export { RegistryRequestApproval, RegistryRequestTable };
